function Step2FabRegistrationContent({
    templateState,
    setTemplateField,
}) {
    return (
        <div className="card">
            <h2>FAB Registration Content</h2>

            <label className="field">
                <span>Divisions Section Title</span>
                <input
                    type="text"
                    value={templateState.divisions_section_title || ""}
                    onChange={(e) =>
                        setTemplateField(
                            "divisions_section_title",
                            e.target.value
                        )
                    }
                    placeholder="FAB Divisions"
                />
            </label>

            <label className="field">
                <span>Locations Section Title</span>
                <input
                    type="text"
                    value={templateState.locations_section_title || ""}
                    onChange={(e) =>
                        setTemplateField(
                            "locations_section_title",
                            e.target.value
                        )
                    }
                    placeholder="Spring 2026 Locations & Start Dates"
                />
            </label>

            <label className="field">
                <span>Divisions</span>
                <textarea
                    rows="8"
                    value={templateState.divisions_text || ""}
                    onChange={(e) =>
                        setTemplateField("divisions_text", e.target.value)
                    }
                    placeholder={`Division 1 (D1) - FAB's highest competitive tier – not for the faint of heart.
Division 2 (D2) - For casual players looking for vigorous competition.
Division 3 (D3) - For casual players looking for less vigorous competition.
Division 4 (D4) - Our Rebound league for those easing back into the game.
Division 5 (D5) - Our “I just came for the free hotdog” league.`}
                />
                <div className="field-help">One division per line.</div>
            </label>

            <label className="field">
                <span>Location Names</span>
                <textarea
                    rows="6"
                    value={templateState.location_names_text || ""}
                    onChange={(e) =>
                        setTemplateField(
                            "location_names_text",
                            e.target.value
                        )
                    }
                    placeholder={`Columbus Tustin Recreation Center
Columbus Tustin Recreation Center
Irvine Valley College Hart Gymnasium`}
                />
                <div className="field-help">
                    One location name per line.
                </div>
            </label>

            <label className="field">
                <span>Location Schedules</span>
                <textarea
                    rows="6"
                    value={templateState.location_schedules_text || ""}
                    onChange={(e) =>
                        setTemplateField(
                            "location_schedules_text",
                            e.target.value
                        )
                    }
                    placeholder={`Tues 6–10pm
Thurs 6–10pm
Sun 6–10pm`}
                />
                <div className="field-help">
                    One schedule per line, same order as names.
                </div>
            </label>

            <label className="field">
                <span>Location Start Dates</span>
                <textarea
                    rows="6"
                    value={templateState.location_start_dates_text || ""}
                    onChange={(e) =>
                        setTemplateField(
                            "location_start_dates_text",
                            e.target.value
                        )
                    }
                    placeholder={`Starts 01/06/2026
Starts 01/08/2026
Starts 01/11/2026`}
                />
                <div className="field-help">
                    One start date per line, same order as names.
                </div>
            </label>

            <label className="field">
                <span>Location URLs</span>
                <textarea
                    rows="6"
                    value={templateState.location_urls_text || ""}
                    onChange={(e) =>
                        setTemplateField(
                            "location_urls_text",
                            e.target.value
                        )
                    }
                    placeholder={`https://www.google.com/maps/...
https://www.google.com/maps/...
https://www.google.com/maps/...`}
                />
                <div className="field-help">
                    One URL per line, same order as names.
                </div>
            </label>

            <label className="field">
                <span>Register Section Title</span>
                <input
                    type="text"
                    value={templateState.register_section_title || ""}
                    onChange={(e) =>
                        setTemplateField(
                            "register_section_title",
                            e.target.value
                        )
                    }
                    placeholder="Register Now!"
                />
            </label>

            <label className="field">
                <span>Register Section Subtitle</span>
                <input
                    type="text"
                    value={templateState.register_section_subtitle || ""}
                    onChange={(e) =>
                        setTemplateField(
                            "register_section_subtitle",
                            e.target.value
                        )
                    }
                    placeholder="Choose the registration path that fits you best."
                />
            </label>

            <label className="field">
                <span>Team Registration Button Label</span>
                <input
                    type="text"
                    value={
                        templateState.team_registration_button_label || ""
                    }
                    onChange={(e) =>
                        setTemplateField(
                            "team_registration_button_label",
                            e.target.value
                        )
                    }
                    placeholder="Team Registration"
                />
            </label>

            <label className="field">
                <span>Team Registration URL</span>
                <input
                    type="text"
                    value={templateState.team_registration_url || ""}
                    onChange={(e) =>
                        setTemplateField(
                            "team_registration_url",
                            e.target.value
                        )
                    }
                    placeholder="https://forms.gle/..."
                />
            </label>

            <label className="field">
                <span>Team Registration Details</span>
                <textarea
                    rows="4"
                    value={
                        templateState.team_registration_details_text || ""
                    }
                    onChange={(e) =>
                        setTemplateField(
                            "team_registration_details_text",
                            e.target.value
                        )
                    }
                    placeholder={`2) Make a payment of team fees of $800
3) Player Registration`}
                />
                <div className="field-help">One detail per line.</div>
            </label>

            <label className="field">
                <span>Player Registration Button Label</span>
                <input
                    type="text"
                    value={
                        templateState.player_registration_button_label || ""
                    }
                    onChange={(e) =>
                        setTemplateField(
                            "player_registration_button_label",
                            e.target.value
                        )
                    }
                    placeholder="SPRING 2026 Player Registration"
                />
            </label>

            <label className="field">
                <span>Player Registration URL</span>
                <input
                    type="text"
                    value={templateState.player_registration_url || ""}
                    onChange={(e) =>
                        setTemplateField(
                            "player_registration_url",
                            e.target.value
                        )
                    }
                    placeholder="https://docs.google.com/forms/..."
                />
            </label>

            <label className="field">
                <span>Player Registration Details</span>
                <textarea
                    rows="3"
                    value={
                        templateState.player_registration_details_text || ""
                    }
                    onChange={(e) =>
                        setTemplateField(
                            "player_registration_details_text",
                            e.target.value
                        )
                    }
                    placeholder=""
                />
                <div className="field-help">One detail per line.</div>
            </label>

            <label className="field">
                <span>Free Agent Registration Button Label</span>
                <input
                    type="text"
                    value={
                        templateState.free_agent_registration_button_label || ""
                    }
                    onChange={(e) =>
                        setTemplateField(
                            "free_agent_registration_button_label",
                            e.target.value
                        )
                    }
                    placeholder="Free Agent Registration"
                />
            </label>

            <label className="field">
                <span>Free Agent Registration URL</span>
                <input
                    type="text"
                    value={
                        templateState.free_agent_registration_url || ""
                    }
                    onChange={(e) =>
                        setTemplateField(
                            "free_agent_registration_url",
                            e.target.value
                        )
                    }
                    placeholder="https://docs.google.com/forms/..."
                />
            </label>

            <label className="field">
                <span>Free Agent Registration Details</span>
                <textarea
                    rows="5"
                    value={
                        templateState.free_agent_registration_details_text ||
                        ""
                    }
                    onChange={(e) =>
                        setTemplateField(
                            "free_agent_registration_details_text",
                            e.target.value
                        )
                    }
                    placeholder={`1) Payment will be requested once a captain makes contact. (Register before payment.)
2) Jerseys required (light & dark, unique number). Discounts from OC Imprints.
Refund Policy – Free agent spots are non-refundable. Special cases credited to next season.`}
                />
                <div className="field-help">One detail per line.</div>
            </label>

            <label className="field">
                <span>OC Imprints URL</span>
                <input
                    type="text"
                    value={templateState.oc_imprints_url || ""}
                    onChange={(e) =>
                        setTemplateField("oc_imprints_url", e.target.value)
                    }
                    placeholder="https://www.ocimprints.com/"
                />
            </label>

            <label className="field">
                <span>Bottom Announcement</span>
                <input
                    type="text"
                    value={templateState.bottom_announcement || ""}
                    onChange={(e) =>
                        setTemplateField(
                            "bottom_announcement",
                            e.target.value
                        )
                    }
                    placeholder="SPRING 2026 REGISTRATION NOW OPEN!!!"
                />
            </label>
        </div>
    );
}

export default Step2FabRegistrationContent;